import * as React from "react";
import { Field, useFormikContext } from "formik";
import { Switch } from "components/common";
import { ControlLabel, Input } from "components/bootstrap";
import { Col } from "security-app/components/common/FormBaseStyles";
import { FormikSelect } from "security-app/components/common/FormikComponents";
import EventProceduresParametersForm from "./EventProceduresParametersForm";
function SearchQueryForm({ savedSearches, readOnly = false, loadParameters = false }) {
  const { values } = useFormikContext();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row" } }, /* @__PURE__ */ React.createElement(Field, { name: "use_saved_search" }, ({ field, form }) => /* @__PURE__ */ React.createElement("div", { style: { display: "flex", flexDirection: "row", alignItems: "center" } }, /* @__PURE__ */ React.createElement(
    Switch,
    {
      "aria-label": "Use saved search",
      id: "toggle_saved_search",
      "data-testid": "saved-search-toggle",
      checked: field.value,
      onChange: () => form.setFieldValue(field.name, !field.value),
      disabled: readOnly
    }
  ), "\xA0Use saved search"))), values.use_saved_search ? /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Field, { name: "saved_search" }, ({ field }) => /* @__PURE__ */ React.createElement(
    FormikSelect,
    {
      field,
      options: savedSearches,
      clearable: false,
      onChange: field.onChange,
      label: "Select Saved Search",
      disabled: readOnly,
      menuPlacement: "top"
    }
  )), loadParameters && /* @__PURE__ */ React.createElement(EventProceduresParametersForm, { viewType: "search", viewId: values == null ? void 0 : values.saved_search, readOnly })) : /* @__PURE__ */ React.createElement(Col, { $fullWidth: true, $width: "100%", $gap: "0.3rem", $align: "stretch" }, /* @__PURE__ */ React.createElement(ControlLabel, null, "Search Query"), /* @__PURE__ */ React.createElement(Field, { name: "query", styled: { width: "100%" } }, ({ field }) => /* @__PURE__ */ React.createElement(
    Input,
    {
      id: field.name,
      name: field.name,
      placeholder: "Search query",
      type: "text",
      value: field.value,
      onChange: field.onChange,
      onBlur: field.onBlur,
      bsStyle: field.error && field.touched ? "error" : null,
      disabled: readOnly
    }
  ))));
}
export default SearchQueryForm;
